module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img2.a25c0efb.jpg";